import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import ExpirenceSummary from "./ExpirenceSummary/expirencesummary";

/**
 * Experience Component for rendering child ExpirenceSummary component
 */
class Experience extends Component {
  render() {
    return (
      <Container
        style={{ maxWidth: "75%", marginTop: "40px !important" }}
        className="card container-card migrator-mt personalDetails-div-1 contact-res"
      >
        <i
          className="material-icons contact-cancel-button pointer"
          onClick={this.props.back}
        >
          cancel
        </i>
        <Row>
          <Col md="12" className=" profile-contact-details-col mx-auto">
            <ExpirenceSummary />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Experience;
